import { render, staticRenderFns } from "./TaskStoreLiuLanList.vue?vue&type=template&id=8c85689c&"
import script from "./TaskStoreLiuLanList.vue?vue&type=script&lang=js&"
export * from "./TaskStoreLiuLanList.vue?vue&type=script&lang=js&"
import style0 from "./TaskStoreLiuLanList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports